import React from 'react';
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
// @ts-nocheck
function ChatSimple() {
  return (
    <chat-bot
      platform_id="d8b97dad-50a8-4d8f-a304-ace78c297cf0"
      user_id="0a84ce99-eaca-4159-a62c-98446d3652bc"
      chatbot_id="69679c78-a21d-4109-98b5-751af30ea175"
    >
      <a href="https://www.chatsimple.ai/?utm_source=widget&utm_medium=referral" />
    </chat-bot>
  );
}

export default ChatSimple;
